import '../../../assets/stylesheets/ClubSlide/ClubData.scss';
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import ItemList from './components/ItemList';
import ClubStats from '../../Units/ClubStats';
import Header from '../components/Header';
import RealTabSwitcher from '../../Units/RealTabSwitcher';
import Calendar from '../../Units/Calendar';
import { clubDataRequest } from '../../../store/actionCreators/club';
import { currentClubData } from '../../../store/selectors';
import { END_DATE } from 'react-dates/constants';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {openDialog} from "../../../store/actionCreators/dialog";

const Data = () => {
    const {id: clubId} = useParams();

    const calendar = Calendar.useCalendar();

    const tabs = useMemo(() => [
        { name: 'yesterday' },
        { name: 'past7Days' },
        { name: 'select', callback: () => calendar.setFocusedInput(END_DATE), icon: 'caret-down' },
    ], [calendar]);

    const [mode, setMode] = useState(tabs[0].name);
    const [currentRange, setCurrentRange] = useState({
        startRange: calendar.since,
        endRange: calendar.till
    });

    const clubData = useSelector(currentClubData);

    const onDatesChange = useCallback(() => setMode('select'), []);

    const dispatch = useDispatch();

    const onExcel = useCallback(() => {
        dispatch(openDialog('exportData', {
            realDialog: true,
            fixed: true,
            grayHeader: true,
            noPaddings: true,
            noFooter: true,
            headerIcon: 'excel',
            title: 'export',
            from: currentRange.startRange,
            to: currentRange.endRange,
        }));
    }, [currentRange]);

    useEffect(() => {
        let startDate = null;
        let endDate = null;

        switch (mode) {
            case 'yesterday': {
                endDate = moment().endOf('day').subtract(1, 'day');
                startDate = moment().startOf('day').subtract(1, 'day');
                break;
            } case 'past7Days': {
                endDate = moment().endOf('day');
                startDate = endDate.clone().subtract(7, 'days').startOf('day');
                break;
            } default: {
                startDate = calendar.since.startOf('day');
                endDate = calendar.till.endOf('day');
            }
        }
        setCurrentRange({
            startRange: startDate,
            endRange: endDate
        });
        dispatch(clubDataRequest(clubId, startDate, endDate));
    }, [mode, calendar]);


    return (
        <div className={`clubData clubPage`}>
            <Header title={'data'} to={`/club/${clubId}`} onExcel={onExcel} />
            <div className={`subheader`}>
                <Calendar.Body {...calendar} currentRange={currentRange} onChange={onDatesChange} />
                <RealTabSwitcher tabs={tabs} onChange={setMode} selected={mode} />
            </div>

            <ClubStats />
            <ItemList data={clubData.playerWinLoss} />
        </div>
    );
};

export default Data;
